import { usePrefetchEffect } from '../../../../../shared/router/usePrefetchEffect';

interface IPrefetchOptions {
	extrasUrl: string;
	fallbackUrl: string;
}

export function usePrefetchNextPage({
	extrasUrl,
	fallbackUrl,
}: IPrefetchOptions) {
	usePrefetchEffect(extrasUrl);
	usePrefetchEffect(fallbackUrl);
}
